// extracted by mini-css-extract-plugin
var _1 = "ZFPjd";
var _2 = "e6EOu";
var _3 = "cammc";
export { _1 as "spinner", _2 as "table", _3 as "typeIcon" }
